<template>
  <tr :class="{'last-month-row': isLastMonthOrOver, 'archived-row': trial.archived_at }">
    <th>
      <a :href="`/storage/${trial.logo_path}`" data-lity v-if="trial.logo_thumb_path">
        <img :src="`/storage/${trial.logo_thumb_path}`" style="width: 100px; max-height: 100px;">
      </a>
    </th>
    <th scope="row">{{ trial.country.name }}</th>
    <td>
      <i class="fa fa-trash-alt" v-if="trial.distributor && trial.distributor.deleted_at"></i>
      <a href="#" @click.prevent="$emit('showDistributorModal', trial.distributor)" v-if="trial.distributor">{{ trial.distributor.company_name }}</a>
    </td>
    <td>{{ trial.key_account ? trial.key_account.name : '' }}</td>
    <td>{{ trial.start_date | date }}</td>
    <td>{{ trial.test_period }}</td>
    <td>{{ trial.stores }}</td>
    <td>{{ trial.formattedEquipmentsName }}</td>
    <td class="text-right">{{ avgSmallPrinters }}</td>
    <td class="text-right">{{ avgLargePrinters }}</td>
    <td>{{ trial.user.name }}</td>
    <td class="text-right nowrap">
      <button type="button" class="btn btn-danger btn-sm"
        @click="$emit('showGalleryModal', trial)"
        style="margin-left: 16px;"
      >
        <i class="fa fa-images"></i>
      </button>
      <a :href="`/trials/${trial.id}`" class="btn btn-sm btn-warning">
        <i class="fa fa-list-alt"></i>
      </a>
      <a :href="`/trials/${trial.id}/burn_rates`" class="btn btn-sm btn-primary"><i class="fa fa-fire"></i></a>
      <template v-if="isAdmin || trial.user_id === authUserId">
        <button type="button" class="btn btn-secondary btn-sm"
          @click="$emit('deleteTrial', trial)"
          style="margin-left: 16px"
        >
          <i class="fa fa-trash-alt"></i>
        </button>
      </template>
    </td>
  </tr>
</template>

<script>
  import { date } from './../../filters'
  import moment from 'moment'
  import avgBurnRateMixin from './avg-burnrate-mixin'

  export default {
    mixins: [avgBurnRateMixin],
    props: ['trial'],
    data() {
      return {
        authUserId: window.authUserId,
        isAdmin: window.isAdmin,
      }
    },
    filters: {
      date,
    },
    computed: {
      isLastMonthOrOver() {
        const endsAt = moment(this.trial.start_date).add(this.trial.test_period, 'months').startOf('month')
        return moment().isSameOrAfter(endsAt)
      },
      getModel() {
        return this.trial
      },
    }
  }
</script>

<style scoped>
  tbody td, tbody th {
    vertical-align: middle
  }
</style>




// WEBPACK FOOTER //
// resources/js/components/trials/Trial.vue